module.exports = __webpack_public_path__ + "img/banner5.4f24a74b.png";